"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportedAdaptiveCards = void 0;
var SupportedAdaptiveCards;
(function (SupportedAdaptiveCards) {
    SupportedAdaptiveCards["Adaptive"] = "application/vnd.microsoft.card.adaptive";
    SupportedAdaptiveCards["Audio"] = "application/vnd.microsoft.card.audio";
    SupportedAdaptiveCards["Hero"] = "application/vnd.microsoft.card.hero";
    SupportedAdaptiveCards["Receipt"] = "application/vnd.microsoft.card.receipt";
    SupportedAdaptiveCards["Thumbnail"] = "application/vnd.microsoft.card.thumbnail";
    SupportedAdaptiveCards["Signin"] = "application/vnd.microsoft.card.signin";
    SupportedAdaptiveCards["OAuth"] = "application/vnd.microsoft.card.oauth";
    SupportedAdaptiveCards["Video"] = "application/vnd.microsoft.card.video";
})(SupportedAdaptiveCards || (exports.SupportedAdaptiveCards = SupportedAdaptiveCards = {}));
//# sourceMappingURL=SupportedAdaptiveCards.js.map